import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { useLanguage } from '../contexts/LanguageContext';
import { getTranslation } from '../translations';
import './Contact.css';

const Contact = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });

  const { language } = useLanguage();
  const t = getTranslation(language);

  return (
    <section id="contact" className="contact" ref={ref}>
      <div className="container">
        <motion.div
          className="contact-header"
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <h2>{t.contact.title}</h2>
          <p>{t.contact.subtitle}</p>
        </motion.div>

        <div className="contact-content">
          {/* AI Research Lead */}
          <motion.div
            className="contact-card"
            initial={{ opacity: 0, y: 50 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ delay: 0.2, duration: 0.6 }}
          >
            <div className="contact-card-inner">
              <h3>{t.contact.aiLead.title}</h3>
              <p className="contact-subtitle">{t.contact.aiLead.subtitle}</p>
              
              <motion.img 
                src="/People/jinhu.jpeg" 
                alt="Jinhu Qi" 
                className="contact-photo"
                whileHover={{ scale: 1.05 }}
              />
              <p className="contact-name">{t.contact.aiLead.name}</p>

              <div className="qr-codes-section">
                <div className="qr-code-item">
                  <p className="qr-label">{t.contact.wechat}</p>
                  <motion.img 
                    src="/qr_code/jinhu_wechat.jpg" 
                    alt="Jinhu WeChat QR Code" 
                    className="qr-code"
                    whileHover={{ scale: 1.05 }}
                  />
                </div>
                <div className="qr-code-item">
                  <p className="qr-label">{t.contact.linkedin}</p>
                  <motion.img 
                    src="/qr_code/jinhu_linkdein.png" 
                    alt="Jinhu LinkedIn QR Code" 
                    className="qr-code"
                    whileHover={{ scale: 1.05 }}
                  />
                  <motion.a 
                    href="https://www.linkedin.com/in/jinhu-qi/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="linkedin-url"
                    whileHover={{ scale: 1.02 }}
                  >
                    linkedin.com/in/jinhu-qi
                  </motion.a>
                </div>
              </div>

              <div className="email-section">
                <p className="email-label">{t.contact.emailLabel}</p>
                <motion.a 
                  href="mailto:jinhuqi@agentecfusion.com"
                  className="email-link"
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  jinhuqi@agentecfusion.com
                </motion.a>
              </div>
            </div>
          </motion.div>

          {/* Vice-President */}
          <motion.div
            className="contact-card"
            initial={{ opacity: 0, y: 50 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ delay: 0.4, duration: 0.6 }}
          >
            <div className="contact-card-inner">
              <h3>{t.contact.vp.title}</h3>
              <p className="contact-subtitle">{t.contact.vp.subtitle}</p>
              
              <motion.img 
                src="/People/qiudan_padded.jpg" 
                alt="Qiudan Wang" 
                className="contact-photo"
                whileHover={{ scale: 1.05 }}
              />
              <p className="contact-name">{t.contact.vp.name}</p>

              <div className="qr-codes-section">
                <div className="qr-code-item">
                  <p className="qr-label">{t.contact.wechat}</p>
                  <motion.img 
                    src="/qr_code/qiudan_wechat.png" 
                    alt="Qiudan WeChat QR Code" 
                    className="qr-code"
                    whileHover={{ scale: 1.05 }}
                  />
                </div>
                {/* LinkedIn pending */}
              </div>

              <div className="email-section">
                <p className="email-label">{t.contact.emailLabel}</p>
                <motion.a 
                  href="mailto:qiudanwang@agentecfusion.com"
                  className="email-link"
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  qiudanwang@agentecfusion.com
                </motion.a>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
